import { client, DEFAULT_HEADERS } from "./defaultClient";
import { WellnessCheck } from "./generated";

export const getWellnessChecks = async (
    answererId: string
): Promise<WellnessCheck[]> => {
    return await client.getWellnessChecks({ answererId }, { mode: "cors" });
};

export const getWellnessCheck = async (id: string): Promise<WellnessCheck> => {
    return await client.getWellnessCheck({ id }, { mode: "cors" });
};

export const getAllWellnessCheck = async (): Promise<WellnessCheck[]> => {
    return await client.getWellnessChecksAll({ mode: "cors" });
};

export const updateLastWatchedAt = async (
    id: string,
    csrfToken: string
): Promise<WellnessCheck> => {
    return await client.patchWellnessChecksIdLastWatchedAt(
        { id },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );
};
